// archiveHandlers/index.js
import { generateAksioma03Reports, buildAccumColumns, getAccumulatedValue } from './aksioma03Handler';
import { generateAksioma01Reports, buildAccumColumnsA01, getAccumulatedValueA01 } from './aksioma01Handler';
import { generateKarat307Reports, buildAccumColumnsK307, getAccumulatedValueK307 } from './karat307Handler';

// Единая точка входа для генерации отчета по устройству
export const generateDeviceReports = async (devName, deviceType, params, headers, deviceFromList) => {
    switch (deviceType) {
        case 'aksioma03':
            return generateAksioma03Reports(devName, params, headers, deviceFromList);
        case 'aksioma01':
            return generateAksioma01Reports(devName, params, headers, deviceFromList);
        case 'karat307':
            return generateKarat307Reports(devName, params, headers, deviceFromList);
        default:
            console.warn(`Неизвестный тип устройства: ${deviceType} для ${devName}`);
            return [];
    }
};

// Получение функции buildAccumColumns в зависимости от типа
export const getBuildAccumColumns = (deviceType) => {
    switch (deviceType) {
        case 'aksioma03': return buildAccumColumns;
        case 'aksioma01': return buildAccumColumnsA01;
        case 'karat307': return buildAccumColumnsK307;
        default: return buildAccumColumns;
    }
};

// Получение функции getAccumulatedValue в зависимости от типа
export const getGetAccumulatedValue = (deviceType) => {
    switch (deviceType) {
        case 'aksioma03': return getAccumulatedValue;
        case 'aksioma01': return getAccumulatedValueA01;
        case 'karat307': return getAccumulatedValueK307;
        default: return getAccumulatedValue;
    }
};

export {
    generateAksioma03Reports,
    generateAksioma01Reports,
    generateKarat307Reports
};